module.exports = __webpack_public_path__ + "static/media/polishing_diamond.77460ba2.webp";